export const INDIA_CITIES = [
    // Uttar Pradesh
    { id: 1, stateId: 26, name: "Lucknow" },
    { id: 2, stateId: 26, name: "Kanpur" },
    { id: 3, stateId: 26, name: "Varanasi" },
    { id: 4, stateId: 26, name: "Prayagraj" },
    { id: 5, stateId: 26, name: "Agra" },
    { id: 6, stateId: 26, name: "Meerut" },
    { id: 7, stateId: 26, name: "Ghaziabad" },
    { id: 8, stateId: 26, name: "Noida" },
    { id: 9, stateId: 26, name: "Gorakhpur" },
    { id: 10, stateId: 26, name: "Bareilly" },
    { id: 11, stateId: 26, name: "Aligarh" },
    { id: 12, stateId: 26, name: "Moradabad" },
    { id: 13, stateId: 26, name: "Saharanpur" },
    { id: 14, stateId: 26, name: "Jhansi" },
    { id: 15, stateId: 26, name: "Mathura" },
    { id: 16, stateId: 26, name: "Ayodhya" },
    { id: 17, stateId: 26, name: "Firozabad" },
    { id: 18, stateId: 26, name: "Shahjahanpur" },
    { id: 19, stateId: 26, name: "Muzaffarnagar" },
    { id: 20, stateId: 26, name: "Rampur" },
    { id: 21, stateId: 26, name: "Basti" },
    { id: 22, stateId: 26, name: "Sitapur" },
    { id: 23, stateId: 26, name: "Unnao" },
    { id: 24, stateId: 26, name: "Raebareli" },
    { id: 25, stateId: 26, name: "Sultanpur" },
    { id: 26, stateId: 26, name: "Deoria" },
    { id: 27, stateId: 26, name: "Azamgarh" },
    { id: 28, stateId: 26, name: "Ballia" },
    { id: 29, stateId: 26, name: "Mau" },
    { id: 30, stateId: 26, name: "Etawah" },
    { id: 31, stateId: 26, name: "Barabanki" },
  
    // Maharashtra
    { id: 56, stateId: 14, name: "Mumbai" },
    { id: 57, stateId: 14, name: "Pune" },
    { id: 58, stateId: 14, name: "Nagpur" },
    { id: 59, stateId: 14, name: "Nashik" },
    { id: 60, stateId: 14, name: "Thane" },
    { id: 61, stateId: 14, name: "Aurangabad" },
    { id: 62, stateId: 14, name: "Solapur" },
    { id: 63, stateId: 14, name: "Amravati" },
    { id: 64, stateId: 14, name: "Kolhapur" },
    { id: 65, stateId: 14, name: "Nanded" },
    { id: 66, stateId: 14, name: "Sangli" },
    { id: 67, stateId: 14, name: "Jalgaon" },
    { id: 68, stateId: 14, name: "Akola" },
    { id: 69, stateId: 14, name: "Latur" },
    { id: 70, stateId: 14, name: "Ahmednagar" },
    { id: 71, stateId: 14, name: "Dhule" },
    { id: 72, stateId: 14, name: "Chandrapur" },
    { id: 73, stateId: 14, name: "Parbhani" },
    { id: 74, stateId: 14, name: "Satara" },
    { id: 75, stateId: 14, name: "Beed" },
    { id: 76, stateId: 14, name: "Ratnagiri" },
    { id: 77, stateId: 14, name: "Wardha" },
    { id: 78, stateId: 14, name: "Yavatmal" },
    { id: 79, stateId: 14, name: "Bhandara" },
    { id: 80, stateId: 14, name: "Osmanabad" },
  
    // Delhi
    { id: 10, stateId: 32, name: "New Delhi" },
    { id: 11, stateId: 32, name: "Dwarka" },
    { id: 12, stateId: 32, name: "Rohini" },
  
    // Karnataka
    { id: 13, stateId: 11, name: "Bengaluru" },
    { id: 14, stateId: 11, name: "Mysuru" },
    { id: 15, stateId: 11, name: "Hubli" },
  
    // Tamil Nadu
    { id: 16, stateId: 23, name: "Chennai" },
    { id: 17, stateId: 23, name: "Coimbatore" },
    { id: 18, stateId: 23, name: "Madurai" },
  
    // Gujarat
    { id: 19, stateId: 7, name: "Ahmedabad" },
    { id: 20, stateId: 7, name: "Surat" },
    { id: 21, stateId: 7, name: "Vadodara" },
  
    // Rajasthan
    { id: 22, stateId: 21, name: "Jaipur" },
    { id: 23, stateId: 21, name: "Jodhpur" },
    { id: 24, stateId: 21, name: "Udaipur" },
  
    // West Bengal
    { id: 25, stateId: 28, name: "Kolkata" },
    { id: 26, stateId: 28, name: "Howrah" },
  
    // Telangana
    { id: 27, stateId: 24, name: "Hyderabad" },
    { id: 28, stateId: 24, name: "Warangal" },
  
    // Kerala
    { id: 29, stateId: 12, name: "Kochi" },
    { id: 30, stateId: 12, name: "Thiruvananthapuram" },
  
    // Punjab
    { id: 31, stateId: 20, name: "Amritsar" },
    { id: 32, stateId: 20, name: "Ludhiana" },
  
    // Bihar
    { id: 31, stateId: 4, name: "Patna" },
  { id: 32, stateId: 4, name: "Gaya" },
  { id: 33, stateId: 4, name: "Bhagalpur" },
  { id: 34, stateId: 4, name: "Muzaffarpur" },
  { id: 35, stateId: 4, name: "Darbhanga" },
  { id: 36, stateId: 4, name: "Purnia" },
  { id: 37, stateId: 4, name: "Bihar Sharif" },
  { id: 38, stateId: 4, name: "Begusarai" },
  { id: 39, stateId: 4, name: "Katihar" },
  { id: 40, stateId: 4, name: "Ara" },
  { id: 41, stateId: 4, name: "Samastipur" },
  { id: 42, stateId: 4, name: "Siwan" },
  { id: 43, stateId: 4, name: "Motihari" },
  { id: 44, stateId: 4, name: "Munger" },
  { id: 45, stateId: 4, name: "Sasaram" },
  { id: 46, stateId: 4, name: "Hajipur" },
  { id: 47, stateId: 4, name: "Chapra" },
  { id: 48, stateId: 4, name: "Buxar" },
  { id: 49, stateId: 4, name: "Madhubani" },
  { id: 50, stateId: 4, name: "Sitamarhi" },
  { id: 51, stateId: 4, name: "Jamui" },
  { id: 52, stateId: 4, name: "Nalanda" },
  { id: 53, stateId: 4, name: "Kishanganj" },
  { id: 54, stateId: 4, name: "Araria" },
  { id: 55, stateId: 4, name: "Jehanabad" },
  
    // Madhya Pradesh
    { id: 35, stateId: 13, name: "Bhopal" },
    { id: 36, stateId: 13, name: "Indore" },
  
    // Odisha
    { id: 37, stateId: 19, name: "Bhubaneswar" },
    { id: 38, stateId: 19, name: "Cuttack" },
  
    // Assam
    { id: 39, stateId: 3, name: "Guwahati" },
    { id: 40, stateId: 3, name: "Silchar" },
  ];